import { z } from 'zod';
import { FlowDataSchema } from './flowData.js';
/**
 * Body `POST /flow-definitions/{id}/diff` accepts. Structural validation only: flow-api
 * additionally checks that each graph's database references resolve.
 *
 * `baseFlowData` defaults to the saved definition's own graph, so a caller comparing unsaved edits
 * against what is stored sends only `newFlowData`.
 */
export const FlowDefinitionDiffBodySchema = z.strictObject({
    newFlowData: FlowDataSchema.describe('The graph to compare.'),
    baseFlowData: FlowDataSchema.describe('The graph to compare against.').optional(),
});
//# sourceMappingURL=diffRequest.js.map